import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import style from './style'

import ScrollArea from '../../../../partials/ScrollArea'

export const BillingTable = props => {
  return (
    <ScrollArea
      style={{
        height: `300px`
      }}
    >
      <Col>
        <Row
          className={css(
            style.list.header,
            style[props.theme.name] ? style[props.theme.name].list.header : null
          )}
        />
        {props.payments.map((item, index) => (
          <TransactionRow
            theme={props.theme}
            key={`${index}_${item.id}`}
            payment={item}
            onClick={props.onItemClick}
            isActive={props.editor.active.id === item.id + ''}
          />
        ))}
      </Col>
    </ScrollArea>
  )
}

export const TransactionRow = props => {
  const dateStr = props.payment.date.split('-')
  dateStr[1] = +dateStr[1] - 1
  const date = new Date(...dateStr)
  const _dates = []
  _dates[0] = {
    month: date.toLocaleString('en-us', { month: 'short' }),
    year: date.getUTCFullYear()
  }

  date.setMonth(date.getMonth() + 1)
  _dates[1] = {
    month: date.toLocaleString('en-us', { month: 'short' }),
    year: date.getUTCFullYear()
  }

  return (
    <Row
      data-pid={props.payment.id}
      onClick={props.onClick}
      className={css(
        style.list.row,
        style[props.theme.name] ? style[props.theme.name].list.row : null,
        props.isActive
          ? style[props.theme.name]
            ? (style.list.activeRow, style[props.theme.name].list.activeRow)
            : style.list.activeRow
          : null
      )}
    >
      <Col>
        <Row>
          <Col className={`d-flex align-items-center justify-content-center`}>
            <span
              className={css(
                style.transaction.span,
                style.transaction.date,
                style.transaction.spanCenter
              )}
            >
              {`${_dates[0].month} ${_dates[0].year}`}
            </span>
          </Col>
        </Row>
        <Row>
          <Col>
            <span
              className={css(
                style.transaction.span,
                style.transaction.date,
                style.transaction.spanCenter
              )}
            >
              {`${_dates[1].month} ${_dates[1].year}`}
            </span>
          </Col>
        </Row>
      </Col>
      <Col className={`d-flex align-items-center justify-content-center`}>
        <span
          className={css(style.transaction.span, style.transaction.spanCenter)}
        >
          {props.payment.amount < 0
            ? `-$${parseFloat(Math.abs(props.payment.amount)).toFixed(2)}`
            : `$${parseFloat(+(props.payment.amount || 0)).toFixed(2)}`}
        </span>
      </Col>
      <Col className={`d-flex align-items-center justify-content-center`}>
        <span
          className={css(style.transaction.span, style.transaction.spanCenter)}
        >
          {props.payment.type}
        </span>
      </Col>
      <Col className={`d-flex align-items-center justify-content-center`}>
        <span
          className={css(
            style.status.label,
            props.payment.paid ? style.status.completed : style.status.pending
          )}
        >
          {props.payment.paid ? `completed` : `pending`}
        </span>
      </Col>
      <Col xs="auto" />
    </Row>
  )

  // return (
  //   <Row
  //     data-userid={props.id}
  //     data-tid={props.report.id}
  //     data-type={props.report._dType}
  //     onClick={props.onClick}
  //     className={css(
  //       style.list.row,
  //       props.active.type === props.report._dType &&
  //       props.active.id === props.report.id + ''
  //         ? style.list.activeRow
  //         : null
  //     )}
  //   >
  //     <Col>
  //       <Row>
  //         <Col>
  //           <span
  //             className={css(
  //               style.transaction.span,
  //               style.transaction.spanCenter
  //             )}
  //           >
  //             {`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`}
  //           </span>
  //         </Col>
  //         <Col>
  //           <span
  //             className={css(
  //               style.transaction.span,
  //               style.transaction.spanCenter
  //             )}
  //           >
  //             ${(+props.report.total).toFixed(2)}
  //           </span>
  //         </Col>
  //         <Col>
  //           <span
  //             className={css(
  //               style.transaction.span,
  //               style.transaction.spanCenter
  //             )}
  //           >
  //             --
  //           </span>
  //         </Col>
  //         <Col className={`d-flex align-items-center justify-content-center`}>
  //           <span className={css(style.status.label, style.status.pending)}>
  //             pending
  //           </span>
  //         </Col>
  //       </Row>
  //     </Col>
  //     <Col xs='auto' className={`d-flex align-items-center`} />
  //   </Row>
  // )
}

export default BillingTable



// WEBPACK FOOTER //
// ./src/components/Community/Main/partials/BillingTable/index.js